import React, { useState, Component } from 'react';
import { AdminSidebar } from './AdminSidebar';
import { AdminDashboardHome } from './dashboard/AdminDashboardHome';
import { LearnersPage } from './users/LearnersPage';
import { TeachersPage } from './users/TeachersPage';
import { SchoolsPage } from './users/SchoolsPage';
import { ParentsPage } from './users/ParentsPage';
import { UserManagementPage } from './users/UserManagementPage';
import { QuestionBankPage } from './content/QuestionBankPage';
import { QualityStatsPage } from './content/QualityStatsPage';
import { ValidationRulesPage } from './content/ValidationRulesPage';
import { SupportContentPage } from './content/SupportContentPage';
import { DeveloperToolsPage } from './system/DeveloperToolsPage';
import { LogsPage } from './system/LogsPage';
import { ConsolePage } from './system/ConsolePage';
import { AdminSettingsPage } from './settings/AdminSettingsPage';
import { AccountsState, Account } from '../../../types/accounts';
import { AppState, ModuleId, Question } from '../../../types';
import { MenuIcon, XIcon } from 'lucide-react';
export type AdminRoute = 'dashboard' | 'schools' | 'teachers' | 'learners' | 'parents' | 'user-management' | 'question-bank' | 'validation-rules' | 'quality-stats' | 'support-content' | 'console' | 'developer-tools' | 'logs' | 'settings';
const PAGE_MAP: Partial<Record<AdminRoute, ComponentType<any>>> = {
  dashboard: AdminDashboardHome,
  learners: LearnersPage,
  teachers: TeachersPage,
  schools: SchoolsPage,
  parents: ParentsPage,
  'user-management': UserManagementPage,
  'question-bank': QuestionBankPage,
  'quality-stats': QualityStatsPage,
  'validation-rules': ValidationRulesPage,
  'support-content': SupportContentPage,
  'developer-tools': DeveloperToolsPage,
  logs: LogsPage,
  console: ConsolePage,
  settings: AdminSettingsPage
};
interface AdminShellProps {
  accounts?: AccountsState;
  getLearnerData?: (learnerId: string) => AppState | null;
  getLearnerModuleMastery?: (learnerId: string, moduleId: ModuleId) => number;
  selectedGroup?: number;
  onNavigate?: (view: string) => void;
  onNavigateToLearner?: (learnerId: string) => void;
  allAccounts?: Account[];
  activeAccountId?: string;
  onSwitchAccount?: (accountId: string) => void;
  onLogout?: () => void;
  questions?: Question[];
  state?: AppState;
  onReturnHome?: () => void;
}
export function AdminShell(props: AdminShellProps) {
  const [activeRoute, setActiveRoute] = useState<AdminRoute>('dashboard');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const PageComponent = PAGE_MAP[activeRoute] ?? AdminDashboardHome;
  return <div className="flex h-screen bg-gray-50 overflow-hidden" data-id="element-43">
      {/* Mobile Header */}
      <div className="md:hidden fixed top-0 left-0 right-0 h-14 bg-white border-b border-gray-200 z-20 flex items-center justify-between px-4" data-id="element-44">
        <div className="font-bold text-gray-900" data-id="element-45">Admin Panel</div>
        <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="p-2 -mr-2 text-gray-600 hover:bg-gray-100 rounded-lg" data-id="element-46">
          {mobileMenuOpen ? <XIcon className="w-5 h-5" data-id="element-47" /> : <MenuIcon className="w-5 h-5" data-id="element-48" />}
        </button>
      </div>

      {/* Mobile Sidebar Overlay */}
      {mobileMenuOpen && <div className="md:hidden fixed inset-0 bg-gray-900/50 z-30" onClick={() => setMobileMenuOpen(false)} data-id="element-49" />}

      {/* Sidebar - Desktop & Mobile Drawer */}
      <div className={`
        fixed inset-y-0 left-0 z-40 transform transition-transform duration-300 ease-in-out md:relative md:translate-x-0
        ${mobileMenuOpen ? 'translate-x-0' : '-translate-x-full'}
      `} data-id="element-50">
        <AdminSidebar activeRoute={activeRoute} onNavigate={route => {
        setActiveRoute(route);
        setMobileMenuOpen(false);
      }} onReturnHome={props.onReturnHome} data-id="element-51" />
      </div>

      {/* Main Content */}
      <main className="flex-1 min-w-0 overflow-hidden pt-14 md:pt-0" data-id="element-52">
        <PageComponent {...props} data-id="element-53" />
      </main>
    </div>;
}